import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';

import 'scrolltofixed';
import 'slick-carousel';

import OneProductForm from '@/modules/module-oneProductForm';
import OneZoom from '@/modules/module-oneZoom';
import OneDrawer from '@/modules/module-oneDrawer';
import OneTabSystem from '@/modules/module-oneTabSystem';
import OneVideo from '@/modules/module-oneVideo';
import OneRecentlyViewed from '@/modules/module-oneRecentlyViewed';
import OneMarketing from '@/modules/module-oneMarketing';
import OneDragToScroll from '@/modules/module-oneDragToScroll';
import OneQuickAdd from '@/modules/module-oneQuickAdd';

import '../../styles/modules/oneSizeChart.scss';
import { PUB_SUB_EVENTS, subscribe } from '@/lib/pubsub';

export default Backbone.View.extend({
    
    initialize: function(opts){
        
        console.log('init PDP');
        
        var self = this

        // $content is <body>
        self.$content = self.$el;
        self.$detailContainer = self.$content.find('.product-detail-container');
        
        self.$media = self.$content.find('.product-media');
        self.$mainImage = self.$media.find('#ProductMediaImages');
        self.$thumbImage = self.$media.find('#ProductMediaThumbs');
        self.$mediaSlider = self.$mainImage.find('.images-wrapper');
        self.$thumbSlider = self.$thumbImage.find('.images-wrapper');

        self.$productCore = self.$content.find('.product-core');
        self.isGiftCard = self.$detailContainer.hasClass('gift-card');
        self.productQty = self.$content.find('.product-qty-container');

        self.$styleGuideModal = self.$content.find('#StyleGuideModal');
        self.$lengthGuideModal = self.$content.find('#LengthGuideModal');
        self.$shadeGuideModal = self.$content.find('#ShadeGuideModal');

        self.$productStyleModule = self.$content.find('.product-style-module');

        self.$recentlyViewed = self.$content.find('.recently-viewed .items');
        
        // Features
        self.enableMiniCore = true;
        self.isScrollingLayout = self.$content.data('layout') == 'scrolling' ? true : false;
        self.isSliderLayout = self.$content.data('layout') == 'slider' ? true : false;
        self.isQuickshopLayout = self.$content.data('layout') == 'quickshop' ? true : false;
        
        if (ORW.enableGTM) {
            ORW.marketing = ORW.marketing || new OneMarketing;
        }

        self.productCore();
        self.initPrice();
        
        if (!self.isGiftCard) {
            self.productMedia();
        }
        
        if (!self.isQuickshopLayout) {
            if (ORW.enableGTM) {
                ORW.marketing.viewItem(self.$productCore);
            }
        } 
        
        if (!self.isGiftCard && !self.isQuickshopLayout) {
            self.zoom();
            self.video();
            self.accordionsAndTabs();
            self.recentlyViewed();

            if (self.$styleGuideModal.length) {
                self.styleGuide();
            }
            if (self.$lengthGuideModal.length) {
                self.lengthGuide();
            }
            if (self.$shadeGuideModal.length) {
                self.shadeGuide();
            }
            if (self.$productStyleModule.length) {
                self.productStyleModule();
            }
            self.mfApply();
            self.productRecommendations();
        }

        OneProductForm.init({
            el: self.el.querySelector('form.add-to-cart-form'),
            preSelect: self.isQuickshopLayout,
            updateURL: !self.isQuickshopLayout,
        });
    },

    events: {
    },
    
    productMedia: function(){
        var self = this;
        var events = {
            'click .image-thumbnail' : function(e){
                e.preventDefault();
                self.$thumbImage.find('.image-thumbnail').removeClass('active');
                var $curr = $(e.currentTarget).addClass('active');
                var index = $curr.data('index') - 1;
                if (self.$media.hasClass('initialized')) {
                    self.$mediaSlider.slick('slickGoTo',index);
                }
            }
        }
        // Update and delegate adding events
        _.extend(self.events, events);
        self.delegateEvents();

        self.$mediaSlider.on('init', function(event, slick, direction){
            self.$media.addClass('initialized');
            $(window).resize();
        });
        self.$mediaSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
            self.$thumbImage.find('.image-thumbnail').removeClass('active');
            self.$thumbImage.find('.image-thumbnail[data-index=' + (nextSlide + 1) + ']').addClass('active');
        })
        self.$thumbSlider.on('init', function(event, slick, direction) {
            self.slickCarouselFix(slick);
        })

        self.$mediaSlider.slick({
            arrows: false,
            dots: true,
            infinite: true,
            slidesToShow: 1,
            speed: 600,
        });
        
        self.$thumbSlider.slick({
            arrows: true,
            asNavFor: self.$mediaSlider,
            infinite: false,
            slidesToScroll: 1,
            slidesToShow: 6,
            speed: 600,
            swipeToSlide: true,
            vertical: true,
            verticalSwiping: true,
        });

        // Hide the "prev" arrow initially
        $('.slick-prev').hide(); // Ensure this is run after the sliders are initialized

        // Show "prev" arrow when "next" is clicked
        self.$thumbSlider.on('click', '.slick-next', function() {
            $('.slick-prev').fadeIn();
        });

        // Hide "prev" arrow when on the first slide
        self.$mediaSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
            if (nextSlide === 0) {
                $('.slick-prev').fadeOut();
            }
        });

        // Main Slick slider
        const $imageSlider = self.$mediaSlider;
        const imageMain = $imageSlider[0]; // JS element object same as $imageSlider[0]
        // Thumb Images
        const $imagesThumbs = self.$thumbSlider;
        const imageThumbs = $imagesThumbs[0]; // JS element object same as $imagesThumbs[0]

        // Check if image elements have more than one value. If not, don't initialize
        const imageVariantValues = new Set(
            [...imageThumbs.querySelectorAll('[data-variant-option-value]')]
            .map(el => el.dataset.variantOptionValue)
            .filter(Boolean) // Remove empty values
        );
        if (imageVariantValues.size <= 1) return;

        subscribe(PUB_SUB_EVENTS.variantOptionsChange, (options) => {

            const filterSelector = options.map(option => `[data-variant-option-value="${ORW.utilities.handleize(option)}"]`).join(',');

            // Maybe no option selected yet
            if (!filterSelector) return

            // Update Main Slick slider (need to do unfilter first to bring back the filtered out slides from previous filter)
            $imageSlider.slick('slickUnfilter');
            const preFilterCheck_main = imageMain.querySelectorAll(filterSelector);
            if (preFilterCheck_main.length === 0) return
            $imageSlider.slick('slickFilter', (_, element) => $(element).find(filterSelector).length > 0);

            // Update Thumb Images
            $imagesThumbs.slick('slickUnfilter');
            const preFilterCheck_thumbs = imageThumbs.querySelectorAll(filterSelector);
            if (preFilterCheck_thumbs === 0) return
            $imagesThumbs.slick('slickFilter', (_, element) => $(element).find(filterSelector).length > 0);
        });
    },

    // from WADB-37 ticket:
    // Slick library has a known issue where vertical carousels will only slide one item at a time even when 'swipeToSlide' is True
    // Fix is taken from here: https://codepen.io/BMI/pen/ZRYeOB  

    slickCarouselFix: function(slickInstance) {
        slickInstance.getSlideCount = function () {
            var _ = this,
              slidesTraversed,
              swipedSlide,
              centerOffset;

            centerOffset =
              _.options.centerMode === true
                ? _.slideWidth * Math.floor(_.options.slidesToShow / 2)
                : 0;

            if (_.options.swipeToSlide === true) {
              _.$slideTrack.find(".slick-slide").each(function (index, slide) {
                var offsetPoint = slide.offsetLeft,
                  outerSize = $(slide).outerWidth();

                if (_.options.vertical === true) {
                  offsetPoint = slide.offsetTop;
                  outerSize = $(slide).outerHeight();
                }
                if (
                  offsetPoint - centerOffset + outerSize / 2 >
                  _.swipeLeft * -1
                ) {
                  swipedSlide = slide;
                  return false;
                }
              });
              slidesTraversed =
                Math.abs(
                  $(swipedSlide).attr("data-slick-index") - _.currentSlide
                ) || 1;

              return slidesTraversed;
            } else {
              return _.options.slidesToScroll;
            }
          };

          slickInstance.getNavigableIndexes = function () {
            var _ = this,
              breakPoint = 0,
              counter = 0,
              indexes = [],
              max;

            if (_.options.infinite === false) {
              max = _.slideCount;
            } else {
              breakPoint = _.options.slideCount * -1;
              counter = _.options.slideCount * -1;
              max = _.slideCount * 2;
            }

            while (breakPoint < max) {
              indexes.push(breakPoint);
              breakPoint = counter + _.options.slidesToScroll;
              counter +=
                _.options.slidesToScroll <= _.options.slidesToShow
                  ? _.options.slidesToScroll
                  : _.options.slidesToShow;
            }

            return indexes;
          };
    },

    initPrice: function() {
        const priceElem = this.el.querySelector('.product-detail-container .price-box');
        subscribe(PUB_SUB_EVENTS.variantChange, (variant) => {
            let html = `<span class="h2 product-price" itemprop="price">${Shopify.formatMoney(variant.price, window.theme.moneyFormat)}</span>`;
            if (variant.compare_at_price) {
                html += `<span class="product-compare-price">${Shopify.formatMoney(variant.compare_at_price, window.theme.moneyFormat)}</span>`
            }
            priceElem.innerHTML = html
        });
    },
    
    productCore: function(){
        var self = this;
        self.productQuantity();
        
        if (!self.isQuickshopLayout) {
            if (self.enableMiniCore) {
                self.productCoreMini();
            }

            self.productCoreScrollFixing();
            self.productCoreSwatchFilter();
            self.productCoreMetafieldTabs();
        }

        const description = self.el.querySelector('.product-description');
        if (!description) return;
        
        const descriptionHeight = description.scrollHeight;
        const descriptionLineHeight = window.getComputedStyle(description).lineHeight;
        const descriptionLineClamp = parseInt(window.getComputedStyle(description).WebkitLineClamp);
        const showMoreBtn = self.el.querySelector('.show-more-btn');
        let descriptionIsTruncated = false;


        if (descriptionLineHeight === 'normal') {
            const descriptionFontsize = parseFloat(window.getComputedStyle(description).fontSize);
            const normalLineHeight = descriptionFontsize * 1.2; // "normal" line height is typically 1.2x font size

            if (descriptionHeight > normalLineHeight * descriptionLineClamp) descriptionIsTruncated = true;
        } else {
            const lineHeight = parseFloat(descriptionLineHeight);

            if (descriptionHeight > lineHeight * descriptionLineClamp) descriptionIsTruncated = true;
        }

        if (!description || !showMoreBtn || !descriptionIsTruncated) {
            showMoreBtn.classList.add('hide');
            description.classList.remove('truncate-description');
            return;
        }

        showMoreBtn.addEventListener('click', function() {
            if (description.classList.contains('truncate-description')) {
                description.classList.remove('truncate-description');
                showMoreBtn.innerText = 'Show Less';
                showMoreBtn.classList.add('active');
            } else {
                description.classList.add('truncate-description');
                showMoreBtn.innerText = 'Show More';
                showMoreBtn.classList.remove('active');
            }
        });
    },

    productCoreMetafieldTabs: function(){
        const self = this;
        const metafieldTabs = self.el.querySelector('.metafield-tabs');

        if (!metafieldTabs) return;

        const tabs = metafieldTabs.querySelectorAll('.tab-title');
        const tabsNumber = tabs.length;
        const sliderContainers = metafieldTabs.querySelectorAll('.mf-tabs-slider-container');
        const productSliders = metafieldTabs.querySelectorAll('.product-slider.slick');

        function matchSliders(e) {
            let activeNumber;

            for (let i = 0; i < tabsNumber; i++) {
                tabs[i].classList.remove('active');
                if (e.currentTarget.classList.contains(`tab-title-${i}`)) {
                    activeNumber = i;
                    e.currentTarget.classList.add('active');
                }
            }

            // display slider that matches the clicked tab title
            sliderContainers.forEach(function (slider) {
                slider.classList.add('hidden');
                if (slider.classList.contains(`mf-tabs-slider-container-${activeNumber}`)) {
                    slider.classList.remove('hidden');
                }
            });
        }

        tabs.forEach(function(tab, index) {
            tab.addEventListener('click', function(e) {
                matchSliders(e);
            });
        });

        let quickadd = false;
        quickadd && quickadd.destroy();
        quickadd = OneQuickAdd.init({ el: metafieldTabs });

        productSliders.forEach(function (slider) {
            $(slider).slick({
                dots: true,
                infinite: true,
                speed: 600,
                slidesToShow: 1,
                arrows: false
            });
        });
    },
    
    productQuantity: function(){
        var self = this;
        var $input = self.productQty.find('.qty-input[type=number]');
        var qty = $input.data('value');

        var events = {
            'click .product-qty-container .qty-btn' : function(e){
                e.preventDefault();
                var $curr = $(e.currentTarget);
                if($curr.hasClass('plus')){
                    $input[0].stepUp()
                } else {
                    $input[0].stepDown();
                }
                $input.attr('value', $input.val())
            }
        }

        // Update and delegate adding events
        _.extend(self.events, events);
        self.delegateEvents();
    },

productCoreSwatchFilter: function() {
    const self = this;
    const categories = self.el.querySelectorAll(`.shade-categories .shade-category`);
    const swatches = self.el.querySelectorAll(`.swatches.linked .swatch`);
    // Read the last selected category from localStorage
    const savedCategory = localStorage.getItem('activeCategory') || 'all';
    // Set the active category based on the saved value
    categories.forEach(category => {
        if (category.dataset.category === savedCategory) {
            category.classList.add('active'); // Add 'active' class to the saved category
        } else {
            category.classList.remove('active'); // Remove 'active' class from other categories
        }
    });
    // Show/hide swatches depending on the active category
    swatches.forEach(swatch => {
        const category = swatch.dataset.category;
        swatch.style.display = category === savedCategory || savedCategory === 'all' ? 'block' : 'none';
    });
    var events = {
        // Handle clicks on category elements that are not currently active
        'click .shade-categories .shade-category:not(.active)': function(e) {
            // Remove 'active' class from all categories
            categories.forEach(category => category.classList.remove('active'));
            // Add 'active' class to the clicked category
            e.currentTarget.classList.add('active');

            const selectedCategory = e.currentTarget.dataset.category;
            // Save the selected category to localStorage
            localStorage.setItem('activeCategory', selectedCategory);
            // Sho/hide swatches based on the selected category
            swatches.forEach(swatch => {
                const category = swatch.dataset.category;
                swatch.style.display = category === selectedCategory || selectedCategory === 'all' ? 'block' : 'none';
            });
        }
    };
    // Update and delegate adding events
    _.extend(self.events, events); 
    self.delegateEvents();
},

    productCoreScrollFixing: function(){
        var self = this;
        var init = function($elm){
            $elm.scrollToFixed({
                zIndex: 2,
                removeOffsets: true,
                dontSetWidth: false,
                marginTop: function(){
                    return $('header.site-header').outerHeight() + 40;
                },
                limit: function() {
                    var limit = $('.scrolling-fix-stopper').offset().top - $(this).height();
                    return limit;
                }
            });
        }

        // Modified scroll to fix for fixing the product media block on desktop
        self.$scrollFixingCore = self.$media.find('.product-media-inner');

        // Not available on Mobile.
        ORW.utilities.mediaCheck(function () {
            init(self.$scrollFixingCore);
        }, function () {
            self.$scrollFixingCore.trigger('detach.ScrollToFixed');
        });
    },
    
    productCoreMini: function(){
        var self = this;
        var init = function($elm){
            console.log('init minicore');
            $elm.scrollToFixed({
                zIndex: 6,
                removeOffsets: true,
                dontSetWidth: true,
                triggerAtBottom: true,
                marginBottom: 0,
                fixed: function(){
                    $(this).addClass('fixed-core fadeInUp animated');
                },
                unfixed: function() {
                    $(this).removeClass('fixed-core fadeInUp animated');
                }
            });
        }
        self.$miniCore = self.$productCore.find('.add-to-cart-wrapper');
        self.$miniCore.trigger('detach.ScrollToFixed');
        init(self.$miniCore);
    },
    
    zoom: function(){
        var self = this;
        OneZoom.init({
            el: self.$media,
            mainImage: self.$mainImage,
            thumbImage: self.$thumbImage
        });
    },
    
    video: function(){
        var self = this;
        var $videos = self.$content.find('.video-wrapper');
        OneVideo.init({
            el: $videos,
            isResponsive: false,
            bgVideo: true,
            autoplay: false
        });
    },
    
    accordionsAndTabs: function(){
        var self = this;
        OneTabSystem.init({
            el: $(`main`)
        });
    },
    
    styleGuide: function() {
        var self = this;
        var styleGuideTrigger = self.$content.find('.style-guide-trigger');
        styleGuideTrigger.removeClass('hidden');
        var styleGuideHtml = $('#StyleGuideModal')[0].outerHTML;
        $('#StyleGuideModal').remove();
        var drawerCtl = OneDrawer.init({
            drawerContent: styleGuideHtml,
            drawerModalId: 'StyleGuideDrawerModal',
            triggerEvent: 'click',
            triggerElem: '.style-guide-trigger',
            initCallback: function(){
                OneTabSystem.init({
                    el: $('#StyleGuideModal')
                });
            },
            openCallback: function(){},
            closeCallback: function(){},
            events: {}
        });
    },

    lengthGuide: function() {
        var self = this;
        var lengthGuideTrigger = self.$content.find('.length-guide-trigger');
        lengthGuideTrigger.removeClass('hidden');
        var lengthGuideHtml = $('#LengthGuideModal')[0].outerHTML;
        $('#LengthGuideModal').remove();
        var drawerCtl = OneDrawer.init({
            drawerContent: lengthGuideHtml,
            drawerModalId: 'LengthGuideDrawerModal',
            triggerEvent: 'click',
            triggerElem: '.length-guide-trigger',
            initCallback: function(){
                OneTabSystem.init({
                    el: $('#LengthGuideModal')
                });
            },
            openCallback: function(){},
            closeCallback: function(){},
            events: {}
        });
    },

    shadeGuide: function() {
        var self = this;
        // var shadeGuideTrigger = self.$content.find('.shade-guide-trigger');
        // shadeGuideTrigger.removeClass('hidden');
        // var shadeGuideHtml = $('#ShadeGuideModal')[0].outerHTML;
        // $('#ShadeGuideModal').remove();
        // var drawerCtl = OneDrawer.init({
        //     drawerContent: shadeGuideHtml,
        //     drawerModalId: 'ShadeGuideDrawerModal',
        //     triggerEvent: 'click',
        //     triggerElem: '.shade-guide-trigger',
        //     initCallback: function(){
        //         OneTabSystem.init({
        //             el: $('#ShadeGuideModal')
        //         });
        //     },
        //     openCallback: function(){},
        //     closeCallback: function(){},
        //     events: {}
        // });

        var shadeGuideLink = self.$content.find('.shade-guide-link');
        if (shadeGuideLink.length){
            shadeGuideLink.removeClass('hidden');
        }
    },

    productStyleModule: function(){
        var self = this;

        var $navContainer = self.$productStyleModule.find('.navigation');
        var $navBlocks = $navContainer.find('.nav-title');
        var $navBlocksNumber = $navBlocks.length;
        var $contentTabs = self.$productStyleModule.find('.content-tab');
    
        function matchTabs(e){
            var $activeNumber;

            for (var $i = 0; $i < $navBlocksNumber; $i++) {
                $(`.nav-title-${$i}`).removeClass('active');
                if($(e.currentTarget).hasClass(`nav-title-${$i}`)){
                    $activeNumber = $i; 
                    e.currentTarget.classList.add('active');
                } 
            }

            // display content-tab that matches the clicked tab title
            $contentTabs.each(function(){
                $(this).addClass('hidden');
                if ($(this).hasClass(`content-tab-${$activeNumber}`)){
                   $(this).removeClass('hidden');
                };
            });
        };
        
        var events = {
            'click .navigation .nav-title' : function(e){
				matchTabs(e);
			}
		};

        // Update and delegate adding events
		_.extend(self.events, events);
		self.delegateEvents();
    },

    mfApply: function () {
        const self = this;
        
        const mfApplyModule = self.el.querySelector('.product-mf-apply');
        if (!mfApplyModule) return;

        OneDragToScroll(mfApplyModule, 800, false);
    },

    productRecommendations: function () {
        const self = this;
        
        const productRecommendationsModule = self.el.querySelector('.product-recommendations-module');
        if (!productRecommendationsModule) return;

        const handleIntersection = (entries, observer) => {
            if (!entries[0].isIntersecting) return;

            observer.unobserve(productRecommendationsModule);

            const url = productRecommendationsModule.dataset.url;

            fetch(url)
                .then(response => response.text())
                .then(text => {
                    const html = document.createElement('div');
                    html.innerHTML = text;
                    const recommendations = html.querySelector('.product-recommendations-module');

                    if (recommendations && recommendations.innerHTML.trim().length) {
                        productRecommendationsModule.innerHTML = recommendations.innerHTML;
                        window.ORW.lazyload && window.ORW.lazyload.update();
                        OneDragToScroll(productRecommendationsModule, 900, false);
                    }
                })
                .catch(e => {
                    console.error(e);
                });
        };

        const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});
        observer.observe(productRecommendationsModule);
    },

    recentlyViewed: function() {

        let self = this;

        OneRecentlyViewed.init({
            el: self.$recentlyViewed
        });
    },
    
    destroy: function() {
        var self = this;
        self.undelegateEvents();
    },
    
    responsive: function () {
        var self = this;
        ORW.utilities.mediaCheck(function () {
            // Desktop actions
        }, function () {
            // Mobile actions
        })
    },
    
    isMobile: function () {
        if ( ORW.responsive == 'small') {
            return true;
        }
        return false;
    }
});